export const FORM_FIELD = {
  NOTIFICATION_URL: {
    name: 'notificationUrl',
    label: 'Notification URL',
    placeholder: 'Enter notification URL',
    rules: [
      { type: 'url', message: "Doesn't look like a valid URL" },
      { required: true, message: 'URL is required' },
    ],
  },
  NOTIFICATION_TEXT: {
    multiline: true,
    label: 'Notification',
    name: 'notificationText',
    placeholder: 'Enter notification text',
    rules: [{ required: true, message: 'Notification text is required' }],
  },
  NOTIFICATION_BUTTON_TEXT: {
    name: 'notificationButtonText',
    label: 'Notification Button Text',
    placeholder: 'Enter button text',
    rules: [{ required: true, message: 'Notification button text is required' }],
  },
  ID: {
    name: 'id',
  },
};

export const INITIAL_VALUES = {
  [FORM_FIELD.NOTIFICATION_BUTTON_TEXT.name]: '',
  [FORM_FIELD.NOTIFICATION_TEXT.name]: '',
  [FORM_FIELD.NOTIFICATION_URL.name]: '',
};
